export default __webpack_public_path__ + "static/varios-digital-nacional-986202b19724d1bd82312e9bcac15717.jpg";